import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

interface HomeAccess {
  label: string;
  description: string;
  icon: string;
  route: string;
}

@Component({
  selector: 'app-home',
  imports: [CommonModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  readonly accessItems: HomeAccess[] = [
    {
      label: 'Comercios',
      description: 'Administra los comercios y consulta su información.',
      icon: 'pi pi-shop',
      route: '/stores'
    },
    {
      label: 'Planes',
      description: 'Gestiona los planes y sus configuraciones disponibles.',
      icon: 'pi pi-shopping-bag',
      route: '/subscriptions'
    },
    {
      label: 'Entrenamiento de IA',
      description: 'Configura y prepara el conocimiento de tus agentes.',
      icon: 'pi pi-android',
      route: '/ai-training-workspace'
    },
    {
      label: 'Simulador de agentes',
      description: 'Prueba el comportamiento de los agentes antes de publicarlos.',
      icon: 'pi pi-android',
      route: '/agent-simulator'
    },
    {
      label: 'Reporte de agentes',
      description: 'Explora conversaciones, mensajes y canales por periodo.',
      icon: 'pi pi-chart-bar',
      route: '/reports/agents'
    },
    {
      label: 'Pagos',
      description: 'Consulta y gestiona la información relacionada con pagos.',
      icon: 'pi pi-receipt',
      route: '/payments'
    }
  ];
}
